//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import draggable from "vuedraggable";
export default {
  name: "homeC",
  components: {
    draggable: draggable
  },
  props: ["childModules", "height", "homeModules"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  created: function created() {},
  computed: {},
  methods: {
    addClick: function addClick(data) {
      this.$emit("addClick", data);
    },
    ifSelected: function ifSelected(val) {
      return this.homeModules.some(function (item) {
        return item.cardType === val.code;
      });
    }
  },
  watch: {},
  filters: {}
};